import { yupResolver } from '@hookform/resolvers/yup';
import React, { useState } from 'react';
import { FormState, useForm } from 'react-hook-form';
import { mapToFieldValues } from './utils/mapToFieldValues';
import { FieldValues, FieldsArray, FaqByLang } from './utils/types';
import { validationSchema } from './utils/validationSchema';
import { CreateServicesHubDto } from '../../../../types/serviceHub.types';
import { ACTIVE_TAB } from './utils/utils';

const EN_FIELD_NAMES: FieldsArray = ['serviceNameEn', 'serviceSubtitleEn', 'serviceShortnameEn', 'seoTitleEn', 'seoDescriptionEn'];
const PL_FIELD_NAMES: FieldsArray = ['serviceNamePl', 'serviceSubtitlePl', 'serviceShortnamePl', 'seoTitlePl', 'seoDescriptionPl'];
const UK_FIELD_NAMES: FieldsArray = ['serviceNameUk', 'serviceSubtitleUk', 'serviceShortnameUk', 'seoTitleUk', 'seoDescriptionUk'];
const RU_FIELD_NAMES: FieldsArray = ['serviceNameRu', 'serviceSubtitleRu', 'serviceShortnameRu', 'seoTitleRu', 'seoDescriptionRu'];

export const hasNonEmptyValues = (
  allDirtyFields:
    | FormState<FieldValues>['dirtyFields']
    | FormState<FieldValues>['errors'],
  fieldsToCheck: Array<keyof FieldValues>,
) => fieldsToCheck.some((fieldName) => allDirtyFields[fieldName]);

export const useServiceHubForm = ({ serviceHub, action}: {
  serviceHub: CreateServicesHubDto | null;
  action: any;
}) => {
  const [activeTabIndex, setActiveTabIndex] = useState(ACTIVE_TAB.POLISH);
  const [loading, setLoading] = useState(false);
  const [serviceFaq, setServiceFaq] = useState<FaqByLang>(() => ({
    faqEn: serviceHub?.faqEn ?? [],
    faqRu: serviceHub?.faqRu ?? [],
    faqPl: serviceHub?.faqPl ?? [],
    faqUk: serviceHub?.faqUk ?? [],
  }));

  const [previewUrl, setPreviewUrl] = useState<string | null>(
    serviceHub?.fileInfo?.fileName
      ? `${process.env.REACT_APP_API_URL_STATIC}/serviceHub/${serviceHub.fileInfo.fileName}`
      : null,
  );
  const [fileName, setFileName] = useState<string>('');

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setFileName(file.name);
      formMethods.setValue('fileInfo', file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };
  const formMethods = useForm<FieldValues>({
    defaultValues: mapToFieldValues(serviceHub),
    mode: 'onSubmit',
    resolver: yupResolver(validationSchema),
  });
  const onSubmit = () => {

    setLoading(true);
    formMethods
      .handleSubmit(
        (data) => {
          action({ ...data,  ...serviceFaq});
        },
        (_) => {},
      )()
      .finally(() => setLoading(false));
  };

  const onTabClick = (_: React.SyntheticEvent, nextIndex: number) => {
    setActiveTabIndex(nextIndex);
  };
  return {
    formMethods,
    onSubmit,
    activeTabIndex,
    onTabClick,
    handleFileChange,
    previewUrl,
    fileName,
    loading,
    serviceFaq,
    setServiceFaq,

    isEnTabValid: !hasNonEmptyValues(
      formMethods.formState.errors,
      EN_FIELD_NAMES,
    ),
    isPlTabValid: !hasNonEmptyValues(
      formMethods.formState.errors,
      PL_FIELD_NAMES,
    ),
    isEuTabValid: !hasNonEmptyValues(
      formMethods.formState.errors,
      UK_FIELD_NAMES,
    ),
    isRuTabValid: !hasNonEmptyValues(
      formMethods.formState.errors,
      RU_FIELD_NAMES,
    ),
  };
};
